// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"kca-z","narrowOptionButtons":"lca-z","noOptions":"mca-z"};